export type BatchStatus = 'uncommitted' | 'committed' | 'in_ops';

export enum BatchStatusEnum {
  UNCOMMITED = 'uncommitted',
  COMMITED = 'committed',
  IN_OPS = 'in_ops',
}
